<template>
  <div class="videoItem">
      <div @click="setVideoSelected" class="clickable-div-button">
        <div class="thumbnail">
          <img :src="thumbnail" alt="thumbnail" />
        </div>
        <div class="details">
          <div class="avatar">
            <template v-if="isAvatarValid">
              <img :src="channelAvatar" alt="ChannelAvatar" @error="handleAvatarError" />
            </template>
            <template v-else>
              <img v-if="cachedChannelAvatar" :src="cachedChannelAvatar" alt="">
              <div v-else class="fallback-avatar">{{ channelInitial }}</div>
            </template>
          </div>
          <div class="videoInfo">
            <div class="videoTitle">
              <h3 class="title_header">{{ videoTitle }}</h3>
            </div>
            <div class="metadata">
              <div class="channelName">
                <p>{{ channelName }}</p>
              </div>
              <div class="postDate">
                <p>{{ postedSince }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// import { computed } from "@vue/reactivity";

export default {
  props: ["post", "index"], // link
  data() {
    return {
      isAvatarValid: true, 
    };
  },
  computed: {
    postIndex() {
      return this.$vnode.key;
    },
    thumbnail() {
      return this.post.body.body.bottomRow.link.imageUrl;
    },
    videoLink() {
      return this.post.body.body.bottomRow.link.externalUrl;
    },
    videoId() {
      return this.post.body.body.bottomRow.link.text.subtitle;
    },
    videoTitle() {
      return this.post.body.body.bottomRow.link.text.title;
    },
    channelInitial() {
      return this.channelName?.charAt(0).toUpperCase() || '?';
    },
    postedSince() {
      const postedDate = new Date(
        this.post.body.header.rightColumn.bottomRow.postedSince
      );
      const now = new Date();
      const timeDiff = now - postedDate;
      const seconds = Math.floor(timeDiff / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      const months = Math.floor(days / 30);
      const years = Math.floor(months / 12);

      if (seconds <= 60) return `${seconds} seconds ago`;
      if (minutes <= 60) return `${minutes}  minutes ago`;
      if (hours <= 24) return `${hours}  hours ago`;
      if (days <= 30) return `${days}  days ago`;
      if (months <= 12) return `${months}  months ago`;
      return `${years} years ago`;
      // return "Years ago"
    },
    videoViews() {
      return "TODO fix"; // youtube apicall doesnt return video views
    },
    channelName() {
      return this.post.body.header.rightColumn.bottomRow.posterName;
    },
    channelAvatar() {
      return this.post.body.header.leftColumn.imageUrl || this.post.pictures[0];
    },
    cachedChannelAvatar(){
      return this.post.pictures[0]
    }
  },
  methods: {
    setVideoSelected() {
      window.scrollTo(0,0)
      this.$store.commit("youtube/SET_VIDEO_SELECTED", this.videoId);
      this.$store.commit("youtube/SET_VIDEO_SELECTED_INDEX", this.postIndex);
      this.$store.commit("youtube/SET_SELECTED_POST", this.post);
    },
    handleAvatarError() {
      console.log('error')
      this.isAvatarValid = false; // Mark the avatar as invalid when the image fails to load
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/youtube-styles.scss";

.videoItem {
  display: flex;
  flex-direction: column;
  width: 100%;
  // max-width: 360px;
  min-width: 150px;
  margin-bottom: 24px;
  
  h3.title_header {
    max-height: 2.5em;
    overflow: hidden;
    line-height: 1.2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
  }

  .clickable-div-button {
    cursor: pointer;
    width: 100%;
  }

  .thumbnail {
    width: 100%;
    aspect-ratio: 16 / 9;
    position: relative;
    margin-bottom: 12px;
    
    img {
      width: 100%;
      height: 100%;
      border-radius: 12px;
      object-fit: cover;
      display: block;
    }
  }

  .details {
    display: flex;
    gap: 12px;
    font-family: $videoItem-videoTitle-font-family;

    .avatar {
      flex-shrink: 0;
      width: $videoItem-avatar-desktop-width;
      height: $videoItem-avatar-desktop-height;
      border-radius: 50%;

      img {
        object-fit: cover;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    
    .videoInfo {
      flex: 1;
      min-width: 0; 
      
      .videoTitle {
        margin-bottom: 4px;
        
        h3 {
          font-size: 14px;
          color: #0f0f0f;
          margin: 0;
        }
      }

      .metadata {
        display: flex;
        flex-direction: column;
        gap: 2px;
        
        .channelName,
        .postDate {
          p {
            margin: 0;
            font-size: 12px;
            color: $videoDetails-color;
            line-height: 1.2;
          }
        }
      }
    }
  }

  .fallback-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #ab5d24; 
    font-size: 14px; 
    color: #ffffff; 
    font-weight: bold;
  }
}

// Use CSS Grid approach for the parent container
// Update your VideoList component CSS to:
/*
#videoList {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}
*/

// Fallback media queries for browsers that don't support @container


</style>